const excludedOrganizationIds = new Set([
  'd4336ad1-e4a2-41f5-ab56-4101b945ee29', // Eppendorf SE tenant (DEV)
  'ffa57562-742f-4037-b210-1be11159151a', // E2E test organization automatic tests (DEV)
  '35500bab-a595-45c2-908e-7106397e14ce', // E2E Tests Secondary Tenant (DEV)
  'd7c4a703-876c-4ba2-9454-09419d4aaa35', // Eppendorf SE tenant (STA)
  '5f194eb6-4aa5-48aa-9bf9-1a04edef608d', // E2E test organization automatic tests (STA)
  'cfc31ac8-a386-4750-a900-18f8ec00633b', // E2E Tests Secondary Tenant (STA)
]);

export const isOrganizationDeletionExcluded = (id: string): boolean => excludedOrganizationIds.has(id.toLowerCase());
